export default __webpack_public_path__ + "static/media/confirm_phone_vetification.d71ab3a9.svg";